import { Component, EventEmitter, Input, OnChanges, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';
import { AppService } from 'src/app/core/services/app.service';
import { ConfigService } from 'src/app/core/services/config.service';
import { EntityService } from 'src/app/core/services/entity.service';
import { UserService } from 'src/app/core/services/user.service';
import * as utils from 'src/app/shared/helpers/utils';
import { DdbbUtils } from 'src/app/shared/helpers/utils';



@Component({
  selector: 'hbo-admin-tools',
  templateUrl: './admin-tools.component.html',
  styleUrls: ['./admin-tools.component.scss']
})
export class AdminToolsComponent implements OnChanges {

  @Input() show!: boolean;
  @Output('callbackAdminTools') callbackAdminTools: EventEmitter<any> = new EventEmitter();

  adminTools: boolean = false;
  entitiesByPage: number = 10000;
  phases: number = 0;
  phasesCompleted: number = 0;
  totalEntities: string = '';
  showContent: boolean = false;

  constructor(
    private translateService: TranslateService,
    private ddbbUtils: DdbbUtils,
    private appService: AppService,
    private configService: ConfigService,
    private entityService: EntityService,
    private userService: UserService
  ) {

  }
  ngOnChanges(changes: SimpleChanges): void {


  }

  refreshHorizonsTeams = () => {
    this.userService.getHorizonsTeams({ perPage: -1 }).subscribe(horizonsTeams => {
      this.configService.setConfigParamsValue('horizonsTeams', horizonsTeams.data);
      this.endAction();
    });
  }

  refresApps = () => {
    this.appService.getApps().subscribe(apps => {
      this.configService.setConfigParamsValue('apps', Object.values(apps));
      this.endAction();
    });
  }

  refreshTeams = () => {
    this.userService.getTeams({ perPage: -1 }).subscribe(res => {
      this.configService.setConfigParamsValue('teams', res.data);
      this.endAction();
    })
  }

  refreshEntities = () => {
    this.entitiesByPage = Number(utils.localStorageGetItem('entitiesByPage')) || this.entitiesByPage;
    this.getEntitiesByPages(utils.localStorageGetItem('user').entityId, 1, this.entitiesByPage);
  }

  refreshCountries = () => {
    this.entityService.getCountries().subscribe(countries => {
      this.csvToArray(countries);
      this.configService.setConfigParamsValue('countries', this.csvToArray(countries));
      this.endAction();
    })

  }

  refreshTimeZones = () => {
    this.entityService.getTimezones().subscribe(timezones => {
      this.configService.setConfigParamsValue('timezones', this.csvToArray(timezones));
      this.endAction();
    });
  }

  csvToArray(csvString: string) {
    const lines = csvString.split('\n');
    const headerValues = lines[0].split(',');
    const dataValues = lines.splice(1).map(dataLine => dataLine.split(','));
    dataValues.pop();
    return dataValues.map(rowValues => {
      const row: any = {};
      headerValues.forEach((headerValue, index) => {
        row[headerValue] = (index < rowValues.length) ? rowValues[index] : null;
      });
      return row;
    });
  }

  getEntitiesByPages = (_entityId: number, _page: number, _perPage: number, _action?: number) => {
    this.ddbbUtils.getEntityChilds(_entityId, _page, _perPage).then(result => {
      if (_page === 1) {
        if (result.total > _perPage) this.ddbbUtils.forceModal('#regularProgressModal', false);
        this.configService.setConfigParamsValue('childEntities', result.data);
        this.phases = Math.ceil(result.total / _perPage);
        this.totalEntities = `${result.total.toString()} ${this.translateService.instant('COMMON.ENTITIES')}`;
      } else {
        let concatanate = this.configService.currentConfigValue.childEntities!.concat(result.data)
        this.configService.setConfigParamsValue('childEntities', concatanate);
      }
      if (_page * _perPage >= result.total) {
        this.phasesCompleted = _page;
        this.ddbbUtils.forceModal('#regularProgressModal', true);
        switch (_action) {
          default:
            this.showContent = true;
            this.endAction();
            break;
        }
      } else {
        this.phasesCompleted = _page;
        this.getEntitiesByPages(_entityId, _page + 1, _perPage);
      }
    })
  }

  endAction = () => {
    this.callbackAdminTools.emit();
  }

}
